// Module
var code = "<span data-bind=\"html: $data\"></span>";
// Exports
export default code;